import * as React from 'react';
import * as styles from './RedesignIntroduction.css';
import { clsx } from 'clsx';

interface IDefaultIntroductionProps {
  breadcrumbs: React.ReactNode;
  backgroundImage: React.ReactNode;
  title: React.ReactNode;
  logo: React.ReactNode;
  contacts: React.ReactNode;
  rating: React.ReactNode;
}

export function RedesignIntroduction({
  breadcrumbs,
  backgroundImage,
  logo,
  title,
  contacts,
  rating,
}: IDefaultIntroductionProps) {
  return (
    <section id="main" className={styles['introduction']}>
      <div className={styles['image']}>{backgroundImage}</div>
      <div className={styles['breadcrumbs']}>{breadcrumbs}</div>
      <div className={clsx(styles['content'], !backgroundImage && styles['content--small'])}>
        <div className={styles['content__wrapper']}>
          <div className={styles['developer']}>
            <div className={styles['logo']}>{logo}</div>
            <div className={styles['developer-info']}>
              {rating}
              {title}
            </div>
          </div>
          <div className={styles['contacts']}>{contacts}</div>
        </div>
      </div>
    </section>
  );
}
